import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'implode'
})
export class ImplodePipe implements PipeTransform {

  transform(value: {}[], key: string, separator = ', '): any {
    return value ? value.map(el => el[key]).join(separator) : '';
  }

}
